import React, { useState } from "react";

const TraningTab = ({ updateChatTabData,chatTabData }) => {
    const [activeAppearanceElementsTab, setActiveAppearanceElementsTab] = useState("main");
    const [isEnableCollectUserDetail, setIsEnableCollectUserDetail] = useState(Number(chatTabData.is_collect_user_details));
    const [isEnableFollowUpMessage, setIsEnableFollowUpMessage] = useState(Number(chatTabData.is_follow_up_message));
    const [followUpMessageText, setFollowUpMessageText] = useState(chatTabData.follow_up_message_text);
    const [assistantInstructionsText, setAssistantInstructionsText] = useState(chatTabData.assistant_instructions_text);

    //Handle Enable Collect User Detailon Change
    const handleEnableCollectUserDetailChange = (e) => {
        const checked = e.target.checked;
        setIsEnableCollectUserDetail(checked);
        updateChatTabData("is_collect_user_details", checked); 
    };

    //Handle Enable Follow Up Message Change
    const handleEnableFollowUpMessageChange = (e) => {
        const checked = e.target.checked;
        setIsEnableFollowUpMessage(checked);
        updateChatTabData("is_follow_up_message", checked); 
    };

    // Handlers Follow Up Message Text Change
    const handleFollowUpMessageTextChange = (event) => {
        const value = event.target.value;
        setFollowUpMessageText(value);
        updateChatTabData("follow_up_message_text", value);
    };

    // Handlers Assistant Instructions Text Change
    const handleAssistantInstructionsChange = (event) => {
        const value = event.target.value;
        setAssistantInstructionsText(value);
        updateChatTabData("assistant_instructions_text", value);
    };

    return (
         <div className="side-baar-inner-setting">
            {activeAppearanceElementsTab === "main" && (
                <>
                    <span>Train Your Assistant</span>
                    <p>To help your customers, the assistant needs to learn from your data. Start by adding information sources.</p>
                    <div className="customize-elements-list">
                        <ul>
                            <li>
                                <button onClick={() => setActiveAppearanceElementsTab("behavior")}>Behavior <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li>
                                <button onClick={() => setActiveAppearanceElementsTab("instructions")}>Instructions <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                        </ul>
                    </div>
                </>
            )}

            {activeAppearanceElementsTab === "behavior" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveAppearanceElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Assistant Behavior</span>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Collect User Details</span>
                                <div className="form-group">
                                    <input
                                        type="checkbox"
                                        id="is_collect_user_details"
                                        className="chkbx-toggle"
                                        checked={isEnableCollectUserDetail}
                                        onChange={handleEnableCollectUserDetailChange}
                                    />
                                    <label htmlFor="is_collect_user_details"></label>
                                </div>
                            </div>
                            <p>Display a contact form to collect user details, either immediately or after the assistant’s first response.</p>
                        </div>
                        <div className="side-baar-box-header">
                            <div className="box-header-row">
                                <span>Follow-up Message</span>
                                <div className="form-group">
                                    <input
                                        type="checkbox"
                                        id="is_follow_up_message"
                                        className="chkbx-toggle"
                                        checked={isEnableFollowUpMessage}
                                        onChange={handleEnableFollowUpMessageChange}
                                    />
                                    <label htmlFor="is_follow_up_message"></label>
                                </div>
                            </div>

                            {Number(chatTabData.is_follow_up_message) === 1 && (
                                <>
                                    <div className="box-header-row welcome-message">
                                        <textarea value={followUpMessageText} onChange={handleFollowUpMessageTextChange} placeholder="Type Message..." defaultValue={followUpMessageText}></textarea>
                                    </div>
                                </>
                            )}

                            <p>Automatically send a message after 5 minutes of user inactivity to check if they need further assistance.</p>
                        </div>
                    </div>
                </>
            )}

            {activeAppearanceElementsTab === "instructions" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveAppearanceElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Instructions</span>
                        <div className="box-header-row welcome-message">
                            <textarea value={assistantInstructionsText} onChange={handleAssistantInstructionsChange} placeholder="Type Message..." defaultValue={assistantInstructionsText} style={{ height: "640px" }} />
                        </div>
                        <p>This instruction tells the assistant about your business and its role. It guides how the assistant should handle customer questions, but its responses will rely on the knowledge base you provide.</p>
                    </div>
                </>
            )}
        </div>
    );
};

export default TraningTab;